/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface MFAStatus
 */
export interface MFAStatus {
    /**
     *
     * @type {boolean}
     * @memberof MFAStatus
     */
    readonly has2faEnabled: boolean;
    /**
     *
     * @type {boolean}
     * @memberof MFAStatus
     */
    readonly hasVerifiedEmail: boolean;
    /**
     *
     * @type {boolean}
     * @memberof MFAStatus
     */
    readonly emailConfigured: boolean;
    /**
     *
     * @type {string}
     * @memberof MFAStatus
     */
    readonly emailMessage: string | null;
    /**
     *
     * @type {string}
     * @memberof MFAStatus
     */
    readonly manageUrl: string;
    /**
     *
     * @type {string}
     * @memberof MFAStatus
     */
    readonly emailUrl: string;
}

/**
 * Check if a given object implements the MFAStatus interface.
 */
export function instanceOfMFAStatus(value: object): value is MFAStatus {
    if (!('has2faEnabled' in value) || value['has2faEnabled'] === undefined) return false;
    if (!('hasVerifiedEmail' in value) || value['hasVerifiedEmail'] === undefined) return false;
    if (!('emailConfigured' in value) || value['emailConfigured'] === undefined) return false;
    if (!('emailMessage' in value) || value['emailMessage'] === undefined) return false;
    if (!('manageUrl' in value) || value['manageUrl'] === undefined) return false;
    if (!('emailUrl' in value) || value['emailUrl'] === undefined) return false;
    return true;
}

export function MFAStatusFromJSON(json: any): MFAStatus {
    return MFAStatusFromJSONTyped(json, false);
}

export function MFAStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): MFAStatus {
    if (json == null) {
        return json;
    }
    return {

        'has2faEnabled': json['has_2fa_enabled'],
        'hasVerifiedEmail': json['has_verified_email'],
        'emailConfigured': json['email_configured'],
        'emailMessage': json['email_message'],
        'manageUrl': json['manage_url'],
        'emailUrl': json['email_url'],
    };
}

  export function MFAStatusToJSON(json: any): MFAStatus {
      return MFAStatusToJSONTyped(json, false);
  }

  export function MFAStatusToJSONTyped(value?: Omit<MFAStatus, 'has_2fa_enabled'|'has_verified_email'|'email_configured'|'email_message'|'manage_url'|'email_url'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

    };
}
